import { render, staticRenderFns } from "./market_title.vue?vue&type=template&id=040a8a9a&scoped=true&"
import script from "./market_title.vue?vue&type=script&lang=ts&"
export * from "./market_title.vue?vue&type=script&lang=ts&"
import style0 from "./market_title.vue?vue&type=style&index=0&id=040a8a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040a8a9a",
  null
  
)

export default component.exports